"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLongPress = void 0;
var _react = require("react");
/* istanbul ignore file -- not used - candidate for removal */

const useLongPress = (callback, delay = 5000) => {
  const timeoutId = (0, _react.useRef)();
  const handleLongPressStart = (0, _react.useCallback)(event => {
    event.preventDefault();
    timeoutId.current = setTimeout(() => {
      callback(event);
    }, delay);
  }, [callback, delay]);
  const handleLongPressEnd = (0, _react.useCallback)(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  }, []);
  return (0, _react.useMemo)(() => ({
    onTouchStart: handleLongPressStart,
    onTouchEnd: handleLongPressEnd
  }), [handleLongPressEnd, handleLongPressStart]);
};
exports.useLongPress = useLongPress;
